import * as React from 'react';
import { FavoriteButton } from '../../components/Favorite/FavoriteButton';
import { Header } from '../../components/FullscreenGallery/Header';
import { HeaderCall } from '../Call/HeaderCall';
import { FavoriteContainer } from '../Favorite';
import { TabsContainer } from '../Tabs/Tabs';

export interface IFullscreenGalleryHeaderProps {
  onClose(): void;
}

export function FullscreenGalleryHeaderContainer({ onClose }: IFullscreenGalleryHeaderProps) {
  return (
    <Header
      onClose={onClose}
      tabs={<TabsContainer />}
      favorite={<FavoriteContainer button={FavoriteButton} buttonSize="M" />}
      call={
        <HeaderCall
          placeType="blockFicheringFullscreenGalleryStickyHeader"
          eventAction="Open_jk_card_fullscreen_gallery"
        />
      }
    />
  );
}
